import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';
import { bankAccountsArraySchema } from 'back-office/shared/components/bank-accounts/bankAccountsValidation';
import { CompagnieFormFieldNames } from './CompagnieFormFieldNames';
import { CompagnieFormValues } from './CompagnieFormValues';

import { gerantValidationRules, optionalCompanyPhoneRule } from 'back-office/shared/components/gerant/gerantFields';
export const compagnieValidationRules: ValidationRules<
  keyof CompagnieFormValues
> = {
  ...gerantValidationRules,
  ...addressValidationRules,
  [CompagnieFormFieldNames.CompanyName]: Yup.string()
    .required('La raison sociale est requise')
    .min(2, 'La raison sociale doit contenir au moins 2 caractères'),
  [CompagnieFormFieldNames.Phone]: optionalCompanyPhoneRule,
  [CompagnieFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIRET est requis')
    .matches(/^\d{14}$/, 'Le SIRET doit contenir 14 chiffres'),
  [CompagnieFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [CompagnieFormFieldNames.RcsCity]: Yup.string().required(
    'La ville RCS est requise'
  ),
  [CompagnieFormFieldNames.RcsNumber]: Yup.string().required(
    'Le numéro RCS est requis'
  ),
  [CompagnieFormFieldNames.BankAccounts]: bankAccountsArraySchema,
  [CompagnieFormFieldNames.FirstName]: Yup.string()
    .required('Le prénom est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères'),
  [CompagnieFormFieldNames.LastName]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [CompagnieFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [CompagnieFormFieldNames.Username]: Yup.string()
    .required("Le nom d'utilisateur est requis")
    .min(3, "Le nom d'utilisateur doit contenir au moins 3 caractères"),
  [CompagnieFormFieldNames.Password]: Yup.string()
    .required('Le mot de passe est requis')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  // Optionnel : une compagnie peut exister comme simple porteur de risque.
  [CompagnieFormFieldNames.PlateformeIds]: Yup.array().of(
    Yup.string().required()
  )
};
